import { getMessagesDiv } from './dom';
import { buildMsgElement } from './message-renderer';
import { updateScrollbar } from './scrollbar';
import type { ChatMessage, PrependHistoryOptions } from './types';

export function prependHistoryMessages(messages: ChatMessage[], options: PrependHistoryOptions = {}): void {
  const messagesDiv = getMessagesDiv();
  if (!messagesDiv) return;
  if (!Array.isArray(messages) || messages.length === 0) return;
  const preserveScroll = options.preserveScroll !== false;
  const skipScrollbar = options.skipScrollbar === true;
  const welcome = messagesDiv.querySelector('.welcome-msg');
  if (welcome) welcome.remove();
  const historyBanner = messagesDiv.querySelector('.history-banner');
  const insertBeforeNode = historyBanner?.nextSibling || messagesDiv.firstChild;
  const frag = document.createDocumentFragment();
  messages.forEach((m) => frag.appendChild(buildMsgElement(m)));
  if (!preserveScroll) {
    messagesDiv.insertBefore(frag, insertBeforeNode);
    if (!skipScrollbar) updateScrollbar();
    return;
  }
  const prevHeight = messagesDiv.scrollHeight;
  const prevScrollTop = messagesDiv.scrollTop;
  messagesDiv.insertBefore(frag, insertBeforeNode);
  messagesDiv.scrollTop = prevScrollTop + (messagesDiv.scrollHeight - prevHeight);
  if (!skipScrollbar) updateScrollbar();
}
